import React from 'react';
import './App.css'; // Assuming your CSS file
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom

const Service6Second = () => {
       return (
           <div className="about-events-main-container"> {/* Main outer container */}
               <div className="about-events-container2">
                   <div className="about-events-wrapper"> {/* Flexbox container */}
                       <div className="about-events-content2">
                           <h2 className="about-header-service2">Photo Shoot Details</h2>
                           <p className="about-events-description2">
                               We offer a personalized photo shoot experience at your preferred time range, ensuring you have the perfect memories to cherish forever.<br/><br/>
                                </p>

                           <ul className="about-events-list2">
                           <h2 className="about-subheader-service2">Package Includes:</h2>
                               <li>- <strong>Minimum Duration: 2 hours</strong></li>
                               <li>- Flexible Timing: Choose your preferred time slot (Day: 9 AM to 5 PM, Night: 6 PM to 11 PM)</li>
                               <li>- Customizable Locations: We can arrange your photo shoot at a location of your choice</li>


                           </ul>
                       </div>

                       <div className="about-events-grid2">
                           <div className="about-events-images2">
                               <img
                                   src={`${process.env.PUBLIC_URL}/package/packphotoshoot.webp`}
                                   className="service2-images3"
                                 
                               />
                           </div>
                       </div>
                   </div>
               </div>
           </div>
       );
   };
export default Service6Second;
